var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_7469_8749)","key":0},React.createElement("path",{"d":"M12.5255 3.9747C12.5255 3.9747 7.45097 9.04922 3.47452 13.0257M12.5255 13.0257C12.5255 13.0257 7.89279 8.39298 3.47452 3.9747","stroke":"#041C1B","strokeLinecap":"square","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_7469_8749"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0 0.5)"})))]);
}

CloseIcon.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
